import React from "react";

import indexOf from "lodash/indexOf";
import { connect } from "react-redux";
import { Formik, Field } from "formik";

import FlipFields from "../ExtraPanels/FlipFields";
import SelectField from "../../components/SelectField";
import PercentField from "../../components/PercentField";
import ScreenWrapper from "../../components/ScreenWrapper";
import MoneyTextField from "../../components/MoneyTextField";

import validations from "./validations4";
import { PAGES } from "../../config/constants";
import pms_loan_terms from "../../constants/pms_loan_terms";
import pms_lien_position from "../../constants/pms_lien_position";
import { MORTGAGE_BROKER } from "../../constants/contact_id_status";
import {
  FIX_FLIP,
  RESIDENTIAL,
  COMMERCIAL,
  TDS,
} from "../../constants/typeOfHomeOptions";

const ConsoleBrok4 = ({
  consoleBrok1,
  setPrevPage,
  setValues,
  type_of_loan,
  id_status,
}) => {
  const initialValues = {
    loan_amount: consoleBrok1.loan_amount,
    lien_position: consoleBrok1.lien_position,
    loan_terms: consoleBrok1.loan_terms,
    rate: consoleBrok1.rate,
    broker_points: consoleBrok1.broker_points,
    broker_processing_fee_5: consoleBrok1.broker_processing_fee_5,
    property_income: consoleBrok1.property_income,
    arv_market_value: consoleBrok1.arv_market_value,
    rehab_amount: consoleBrok1.rehab_amount,
    sq_ft_addition: consoleBrok1.sq_ft_addition,
  };

  return (
    <ScreenWrapper>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          setValues(values);
        }}
        validate={validations}
      >
        {({ handleSubmit }) => (
          <React.Fragment>
            <Field
              name="loan_amount"
              component={MoneyTextField}
              label="Loan Amount"
              required
              formControlStyle={{ style: { marginTop: 10 } }}
            />

            <Field
              name="lien_position"
              component={SelectField}
              label="Lien Position *"
              options={pms_lien_position}
              required
              formControlStyle={{ style: { marginTop: 10 } }}
            />

            <Field
              name="loan_terms"
              component={SelectField}
              label="Loan Term Requested *"
              options={pms_loan_terms}
              required
              formControlStyle={{ style: { marginTop: 10 } }}
            />

            <Field
              name="interest_rate"
              component={PercentField}
              label="Interest Rate Requested"
              required
              formControlStyle={{ style: { marginTop: 10 } }}
            />

            {id_status === MORTGAGE_BROKER.value && (
              <React.Fragment>
                <Field
                  name="broker_points"
                  component={PercentField}
                  label="Broker Points"
                  required
                  formControlStyle={{ style: { marginTop: 10 } }}
                />

                <Field
                  name="broker_processing_fee_5"
                  component={MoneyTextField}
                  label="Broker Processing"
                  required
                  formControlStyle={{ style: { marginTop: 10 } }}
                />
              </React.Fragment>
            )}

            {type_of_loan === FIX_FLIP.value && <FlipFields />}

            {indexOf(
              [RESIDENTIAL.value, COMMERCIAL.value, TDS.value],
              type_of_loan
            ) !== -1 && (
              <Field
                name="property_income"
                component={MoneyTextField}
                label="Rental Income"
                required
                formControlStyle={{ style: { marginTop: 10 } }}
              />
            )}

            <div className="container-fluid">
              <div style={{ marginTop: 10 }}>
                <div style={{ float: "left" }}>
                  <button
                    type="button"
                    className="cstm_btn cstm_btn-green"
                    onClick={setPrevPage}
                  >
                    Back
                  </button>
                </div>
                <div style={{ float: "right" }}>
                  <button
                    type="button"
                    className="cstm_btn cstm_btn-green"
                    onClick={handleSubmit}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </Formik>
    </ScreenWrapper>
  );
};

const mapState = (state) => {
  return {
    consoleBrok1: state.consoleBrok1,
    type_of_loan: state.form.accounts.type_of_loan,
    id_status: state.form.contacts.id_status,
  };
};

const mapDispatch = (dispatch) => {
  return {
    setPrevPage: () => {
      dispatch({
        type: "SET_PAGE",
        payload: PAGES.CONSOLE_BROOK_3,
      });
    },

    setValues: (values) => {
      dispatch({
        type: "SET_CONSOLE_BROK1",
        payload: values,
      });

      dispatch({
        type: "SET_PAGE",
        payload: PAGES.LOAN_SUMMARY,
      });
    },
  };
};

export default connect(mapState, mapDispatch)(ConsoleBrok4);



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/ConsoleBrok4.js